<vg-header></vg-header>
<div class="root-container-vg-progress">
    <div class="container container-vg-progress">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-9 col-container-vg-progress">
                <vg-progress [current]="currentProgress"></vg-progress>
            </div>
        </div>
    </div>
</div>
<router-outlet></router-outlet>
<vg-footer></vg-footer>
